import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'
import {IUserList} from './getUserList'

export interface IPro {
    id: string
    user_id: string
    pay_method: string
    tx_id: string
    chain: string
    amount: number
    period: number
    start_at: string
    end_at: string
    created_at: string
    updated_at: string
    email: string
    name: string
    thumbnail: string
    email_confirmed: boolean
    phone: string
    phone_confirmed: boolean
    active_exchanges: any
}

export const getProList = async (size: number = 30, current: number = 1): Promise<ApiRes<IUserList[]>> => {
    return await apiGet(API_URL, `admin/pro/users?page_size=${size}&current_page=${current}`)
}
